import React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { SignupPage } from '../SignupPage';
import { submitCreateAccountForm, showRequestResetPassword } from '../../user';
import { useCurrentUserCtx } from '../../contexts/CurrentUser';

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: data => {
    const {
      location: { search },
      fetchCurrentUser,
    } = ownProps;
    const { ref } = queryString.parse(search);
    // Passing isFromSignup=true to fetchCurrentUser() ensures mParticle
    // 'onboarding_completed' event is fired in callback
    return dispatch(
      submitCreateAccountForm(data, () => fetchCurrentUser(true), {
        doAddToEmailList: true,
        ref,
      })
    );
  },
  onClickRequestResetPassword: () =>
    dispatch(showRequestResetPassword('Forgot Password')),
});

const mapStateToProps = ({ routing }) => ({
  routing,
});

const SignUpPageContainerWithRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(SignupPage);

export default function SignUpPageWrapper(props) {
  const { fetchCurrentUser } = useCurrentUserCtx();
  return (
    <SignUpPageContainerWithRedux
      {...props}
      fetchCurrentUser={fetchCurrentUser}
    />
  );
}
